module.exports = __webpack_public_path__ + "img/ToDone.428100ab.svg";